import SectionLink from "@/components/powlo/SectionLink";

export default function CtaBanner({
  heading,
  body,
  ctaLabel = "Design my system →",
  ctaHref = "/#check",
  secondaryCtaLabel,
  secondaryCtaHref,
}: {
  heading: React.ReactNode;
  body: string;
  ctaLabel?: string;
  ctaHref?: string;
  secondaryCtaLabel?: string;
  secondaryCtaHref?: string;
}) {
  return (
    <section className="mx-4 mb-14 rounded-[40px] px-6 py-16 text-white dotted-indigo sm:px-10 lg:mx-10 lg:px-20">
      <div className="flex flex-col items-start justify-between gap-8 lg:flex-row lg:items-center">
        <div className="flex max-w-2xl flex-col gap-4">
          <h2 className="m-0 font-display text-4xl font-bold leading-[1.05] tracking-tight sm:text-5xl">
            {heading}
          </h2>
          <p className="m-0 text-lg leading-relaxed text-[#E6E5FF]">{body}</p>
        </div>
        <div className="flex w-full shrink-0 flex-col gap-3 sm:w-auto">
          <SectionLink
            href={ctaHref}
            className="flex h-16 shrink-0 items-center justify-center rounded-2xl border-2 border-ink bg-lime px-8 font-display text-lg font-bold tracking-tight text-ink no-underline shadow-hardSm"
          >
            {ctaLabel}
          </SectionLink>
          {secondaryCtaLabel && secondaryCtaHref && (
            <SectionLink
              href={secondaryCtaHref}
              className="flex h-14 shrink-0 items-center justify-center rounded-2xl border-2 border-white/70 px-8 font-display text-base font-bold tracking-tight text-white no-underline"
            >
              {secondaryCtaLabel}
            </SectionLink>
          )}
        </div>
      </div>
    </section>
  );
}
